export const palette = {
  colorBackground: 'rgb(249, 250, 255)',
  red: '#ff405d',
  orange: '#ff7400',
  lightpurple: '#EAEBFE',
  lightMaxpurple: 'rgba(83, 115, 252, 0.2)',
  lightgray: '#E0E1EE',
  purple: '#4749FB',
  accent: '#F3764F',
  yellow: '#FFD700',
  blue: '#5373fc',
  lightBlue: 'rgba(83,115,252,0.4)',
  blueBg: '#F9FAFF',
  black: '#000035',
  white: '#ffffff',
  ultraPale: 'rgb(249, 249, 249)',
  lightBS:
    ' 0 0.3px 1.1px -23px rgba(0, 0, 0, 0.016),\n' +
    '  0 0.7px 2.4px -23px rgba(0, 0, 0, 0.023),\n' +
    '  0 1.1px 4.1px -23px rgba(0, 0, 0, 0.028),\n' +
    '  0 1.7px 6.4px -23px rgba(0, 0, 0, 0.033),\n' +
    '  0 2.6px 9.4px -23px rgba(0, 0, 0, 0.037),\n' +
    '  0 3.8px 13.8px -23px rgba(0, 0, 0, 0.042),\n' +
    '  0 5.7px 20.8px -23px rgba(0, 0, 0, 0.047),\n' +
    '  0 9.1px 33.1px -23px rgba(0, 0, 0, 0.054),\n' +
    '  0 17px 62px -23px rgba(0, 0, 0, 0.07)',
  regBS: 'rgba(0, 0, 0, 0.16) 0px 3px 10px',
  heavyBS: 'rgba(0, 0, 0, 0.43) 0px 0px 43px -8px',
  link: '#1264a3',
  light: " 'pieza-light', sans-serif",
  reg: " 'pieza-reg', sans-serif",
  med: "'pieza-med', sans-serif",
  bold: "'pieza-bold', sans-serif",
  nereg: ' futura-pt, sans-serif',
  lightred: 'rgba(255,64,93,0.5)',
  newBlue: '#1D1D38',
  BSnewCard:
    ' 0 0.3px 1.1px -23px rgba(0, 0, 0, 0.016),\n' +
    '  0 0.7px 2.4px -23px rgba(0, 0, 0, 0.023),\n' +
    '  0 1.1px 4.1px -23px rgba(0, 0, 0, 0.028),\n' +
    '  0 1.7px 6.4px -23px rgba(0, 0, 0, 0.033),\n' +
    '  0 2.6px 9.4px -23px rgba(0, 0, 0, 0.037),\n' +
    '  0 3.8px 13.8px -23px rgba(0, 0, 0, 0.042),\n' +
    '  0 5.7px 20.8px -23px rgba(0, 0, 0, 0.047),\n' +
    '  0 9.1px 33.1px -23px rgba(0, 0, 0, 0.054),\n' +
    '  0 17px 62px -23px rgba(0, 0, 0, 0.07)',
  grayNew: 'rgba(112,112,112,0.6)',
  green: 'rgb(97,149,141)',
  backgroundGeneral: 'rgb(249,250,255)',
  colorLetter: 'rgb(38, 38, 39)',
  // Valores de las analiticas
  accentColorAnalitics: '#0058FF',
  customColor: '#5373fc',
};

export const paletteLandings = {
  suisseIntMed: "'suisse-int-med', sans-serif",
  suisseIntBook: "'suisse-int-book', sans-serif",
  suisseIntBlack: "'suisse-int-black', sans-serif",
  suisseIntBold: "'suisse-int-bold', sans-serif",
  suisseWorksBold: "'suisse-works-bold', sans-serif",
  suisseLight: "'suisse-int-light', sans-serif",
  accentColor: '#3E7C72',
};
